<div class="d-flex align-items-center bg-primary-soft-background s-p-4">
  <div
    class="col-md-2 bg-primary-brand-color c-white border rounded-circle s-w-12 s-h-12 d-flex align-items-center justify-content-center"
  >
    <mat-icon> attach_file </mat-icon>
  </div>
  <div class="s-ms-4 col-md-9">
    <strong class="c-primary-brand-color">
      {{ file().name }}
    </strong>
    <small class="d-block">
      {{ file().size | fileSize }}
    </small>
  </div>
  <div class="col-md-1">
    <button class="border-0 bg-transparent" (click)="removeItem(file())">
      <mat-icon class="c-status-error"> delete </mat-icon>
    </button>
  </div>
</div>
